import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Icons } from "./Machine360Icons";

export const Machine360KpiCards = ({ kpiCards, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="m360-kpi-grid">
        {[0, 1, 2, 3].map((idx) => (
          <div key={idx} className="m360-kpi-card">
            {/* Left Circular Icon Skeleton */}
            <div className="m360-kpi-icon-wrap" style={{ background: "transparent" }}>
              <Skeleton circle={true} height={42} width={42} />
            </div>

            {/* Right Metric Content Skeleton */}
            <div className="m360-kpi-content" style={{ width: "100%" }}>
              <Skeleton height={14} width={75} />
              <div style={{ margin: "4px 0" }}>
                <Skeleton height={26} width={65} />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!kpiCards || kpiCards.length === 0) return null;

  const renderIcon = (iconType) => {
    switch (iconType) {
      case "play":
        return <Icons.Play size={18} />;
      case "check":
        return <Icons.Check size={20} />;
      case "clock":
        return <Icons.Clock size={19} />;
      case "dollar":
        return <Icons.Dollar size={19} />;
      default:
        return null;
    }
  };

  return (
    <div className="m360-kpi-grid">
      {kpiCards.map((card) => {
        return (
          <div key={card.id} className="m360-kpi-card">
            {/* Left Circular Icon */}
            <div className={`m360-kpi-icon-wrap m360-theme-${card.colorTheme}`}>
              {renderIcon(card.iconType)}
            </div>

            {/* Right Metric Content */}
            <div className="m360-kpi-content">
              <span className="m360-kpi-title">{card.title}</span>
              <div className="m360-kpi-value">{card.value}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
